import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import breadcrumbs from "./breadcrumbs.module";
import claim from "./claim.module";
import client from "./client.module";
import consent from "./consent.module";
import contents from "./content.module";
import jwt from "./jwt.module";
import loading from "./loading.module";
import locale from "./locale.module";
import morStore from "./morStore.module";
import participant from "./participant.module";
import program from "./program.module";
import programGroup from "./programGroup.module";
import property from "./property.module";
import storeProgram from "./storeProgram.module";
import user from "./user.module";

const vuexLocalStorage = new VuexPersist({
  key: "gapp-vuex",
  storage: window.localStorage,

  // Only keep certain state variables in local storage.  For the rest, recalculate
  reducer: state => ({
    user: state.user,
    jwt: state.jwt,
    client: state.client,
    morStore: state.morStore,
    program: state.program,
    programGroup: state.programGroup,
    participant: state.participant,
    property: state.property,
    claim: state.claim,
    storeProgram: state.storeProgram,
    locale: state.locale,
    contents: state.content,
    loading: state.loading,
    consent: state.consent
  })
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    jwt,
    breadcrumbs,
    client,
    morStore,
    program,
    programGroup,
    participant,
    claim,
    storeProgram,
    locale,
    contents,
    loading,
    consent,
    property
  },
  plugins: [vuexLocalStorage.plugin]
});
